function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.335 4.502l-1.366-.288-.364-1.347v-.001a2.445 2.445 0 00-2.047-1.79 2.441 2.441 0 00-2.438 1.21l-.694 1.21-1.396-.07h0l-.014-.001a2.484 2.484 0 00-2.33 1.396h0l-.003.007a2.437 2.437 0 00.399 2.692l.002.003.937 1.034-.494 1.307a2.429 2.429 0 00.602 2.649 2.438 2.438 0 002.68.454s0 0 0 0l1.273-.572 1.084.873.002.002a2.444 2.444 0 002.711.24 2.445 2.445 0 001.262-2.41h0l-.149-1.388 1.172-.764.002-.001a2.444 2.444 0 001.083-2.378 1.016 1.016 0 00-.014-.12 2.441 2.441 0 00-1.899-1.947h0z",
  fill: "#F6335D",
  stroke: "#fff",
  strokeWidth: "2",
  strokeLinejoin: "round"
})));